import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninGuestSelected = (
  track: RedcatAnalyticsStore['track'],
  { entryPoint }: { entryPoint: string },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.GuestSelected,
    properties: {
      entry_point: entryPoint,
    },
  };

  track(event);
};
